import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/styles/main.scss'
import './assets/styles/fixes.css'
import './plugins/axios'
import appService from './services/appService'
import categoryService from './services/categoryService'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)

// Initialiser les services de l'application
appService.init()

// Précharger les catégories au démarrage de l'application
store.dispatch('ui/fetchCategories')
  .catch(error => console.error('Erreur lors du chargement initial des catégories:', error))

app.mount('#app')